import { atomFamily } from "jotai/utils";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

const sessionPayeeFinalisedAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`payeeFinalised-${sessionId}`, false)
);

export const payeeFinalisedAtom = createDerivedSessionAtom<boolean>(sessionPayeeFinalisedAtom);
